




















/* Created- 15 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ContentSearchHit, ContentSearchDataOfContentSearchHit } from "../../../Generated/ParticaAPI";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";

@Component(
	{
		name: "SearchPreview",
		components: {}
	})
export default class SearchPreview extends Vue {
	@Prop() private hit: ContentSearchHit; // your data 
	private getImage(hit: ContentSearchHit): string {
		if (hit.featuredImage === null) {
			return "https://dashboard.partica.online/app2/img/no-image.jpg";
		} else {
			return `${this.$store.state.config.thumburl}${hit.issueGuid}/embedimage/${hit.featuredImage}`.replace(/.jpg/gi, ".600.jpg");
		}
	}
	private preview(hit: ContentSearchDataOfContentSearchHit) {
		this.$emit("partica-event", {
			action: eParticaAction.ARTICLE_SELECT,
			item: hit
		} as ParticaEvent);
	}
}
